
export default function MembershipBenefitsSection() {
  const benefits = [
    {
      icon: 'ri-book-open-line',
      title: 'Educational Resources',
      description: 'Access to exclusive study materials, case studies, and interdisciplinary learning resources',
      color: 'blue'
    },
    {
      icon: 'ri-award-line',
      title: 'Scholarships & Awards',
      description: 'Competitive scholarships and recognition programs for outstanding academic achievement',
      color: 'green'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Exclusive Events',
      description: 'Student-only conferences, workshops, and networking events across Canada',
      color: 'purple'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Career Development',
      description: 'Job placement assistance, internship opportunities, and career mentorship programs',
      color: 'orange'
    },
    {
      icon: 'ri-global-line',
      title: 'International Exchange',
      description: 'Study abroad opportunities and international conference participation',
      color: 'indigo'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Wellness Support',
      description: 'Mental health resources, stress management workshops, and peer support networks',
      color: 'pink'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600', 
    purple: 'bg-purple-100 text-purple-600',
    orange: 'bg-orange-100 text-orange-600',
    indigo: 'bg-indigo-100 text-indigo-600',
    pink: 'bg-pink-100 text-pink-600'
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Student Membership Benefits
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join thousands of pharmacy and veterinary students across Canada and unlock exclusive benefits designed to support your academic and professional journey
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className={`w-16 h-16 ${colorClasses[benefit.color]} rounded-full flex items-center justify-center mb-4`}>
                <i className={`${benefit.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-blue-900 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">
            Ready to Join?
          </h3>
          <p className="text-blue-100 mb-6 text-lg">
            Student membership is only $25/year and includes all benefits listed above
          </p>
          <button className="bg-white text-blue-900 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer">
            Apply for Student Membership
          </button>
        </div>
      </div>
    </section>
  );
}
